import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { ProductStatus } from "@/components/ProductStatus";

const documentTypes = [
  { key: "cpnp", label: "Schede CPNP/INCI", has: (item) => item.inci_approved },
  { key: "sds", label: "Schede di Sicurezza", has: (item) => item.has_sds },
];

export const ClientEmailAvailability = ({ items, kinds }) => {
  const [expanded, setExpanded] = useState(null);
  const selectedTypes = documentTypes.filter(({ key }) => kinds[key]);
  const rows = selectedTypes.map((type) => ({
    ...type,
    missing: items.filter((item) => !type.has(item)),
  }));
  const incomplete = rows.filter(({ missing }) => missing.length > 0);
  if (!rows.length) return null;

  return (
    <div className="mb-5 space-y-2" data-testid="cp-bulk-email-availability">
      {rows.map(({ key, label, missing }) => (
        <div key={key}
             className={`border rounded-sm p-3 text-xs flex flex-wrap items-center justify-between gap-2 ${missing.length ? "workflow-ux-panel--warning" : "workflow-ux-panel--success"}`}
             data-testid={`cp-bulk-email-availability-${key}`}>
          <span className="font-medium" data-testid={`cp-bulk-email-availability-count-${key}`}>
            {label}: {items.length - missing.length}/{items.length} prodotti disponibili
          </span>
          <ProductStatus tone={missing.length ? "warning" : "success"} testId={`cp-bulk-email-availability-status-${key}`}>
            {missing.length ? "Mancante" : "Disponibile"}
          </ProductStatus>
        </div>
      ))}
      {incomplete.length > 0 && (
        <div className="border rounded-sm p-3 workflow-ux-panel--warning"
             role="alert" data-testid="cp-bulk-email-missing-panel">
          <p className="text-[11px] mb-2">
            Attenzione: alcuni prodotti selezionati non hanno l'elemento da inviare (verranno esclusi dall'allegato).
          </p>
          <div className="space-y-1.5">
            {incomplete.map(({ key, label, missing }) => {
              const open = expanded === key;
              return (
                <div key={key}>
                  <button type="button" onClick={() => setExpanded(open ? null : key)}
                          aria-expanded={open} aria-controls={`cp-missing-${key}`}
                          className="inline-flex items-center gap-1 text-[11px] hover:opacity-70"
                          data-testid={`cp-bulk-email-missing-toggle-${key}`}>
                    <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
                    {label}: {missing.length} senza questo elemento
                  </button>
                  {open && (
                    <div id={`cp-missing-${key}`} className="mt-1 max-h-32 overflow-y-auto border border-[#F0EAEA] bg-white rounded-sm"
                         data-testid={`cp-bulk-email-missing-list-${key}`}>
                      {missing.map((item) => (
                        <div key={item.id} className="flex items-baseline gap-2 px-2.5 py-1 text-[11px] border-b border-[#F5EDED] last:border-0 min-w-0"
                             data-testid={`cp-bulk-email-missing-product-${key}-${item.id}`}>
                          <span className="font-mono text-[#8C3A3A] shrink-0" data-testid={`cp-bulk-email-missing-code-${key}-${item.id}`}>{item.code}</span>
                          <span className="text-[#5A5A5A] truncate min-w-0" data-testid={`cp-bulk-email-missing-name-${key}-${item.id}`}>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};